// @flow

import React, { Component } from 'react'
import styled from 'styled-components'
import type { ReactComponentStyled } from 'styled-components'
import color from 'michelangelo/dist/Components/styles/color'

type RichTextProps = {
  html: string
}
type RichTextState = {
  richTextWidth: number
}

const RichTextDiv: ReactComponentStyled<{}> = styled.div`
  text-align: inherit;
`

RichTextDiv.displayName = 'RichTextDiv'
const RichTextCenter: ReactComponentStyled<{}> = styled.div`
  display: flex;
  padding-top: 1%;
  margin: 2%;
  align-items: center;
  justify-content: center;

  @media (min-width: 1200px) {
    padding-right: 22%;
    padding-left: 22%;
  }
  @media (min-width: 825px) and (max-width: 1199px) {
    padding-right: 10%;
    padding-left: 10%;
  }
  @media (max-width: 411px) {
    padding-top: 2%;
  }
`
RichTextCenter.displayName = 'RichTextCenter'

const RichTextWrapper: ReactComponentStyled<{}> = styled.div`
  width: ${(props) => props.richTextWidth}px;
  padding: 24px 32px;
  border: 0.6px solid ${color.lightDefault};
  @media (max-width: 825px) {
    padding-left: 16px;
    padding-right: 16px;
  }
  @media (max-width: 411px) {
    padding-top: 16px;
    padding-bottom: 16px;
    padding-left: 24px;
    padding-right: 24px;
  }
  * {
    max-width: ${(props) => props.richTextWidth * 0.95}px !important;
  }

  img {
    height: auto !important;
    display: inline !important;
  }

  ul {
    padding-inline-start: inherit;
  }
`
RichTextWrapper.displayName = 'RichTextWrapper'

class RichText extends Component<RichTextProps, RichTextState> {
  constructor (props: RichTextProps) {
    super(props)
    this.state = { richTextWidth: this.getRichTextWidth() }
  }

  getRichTextWidth (): number {
    const width = window.innerWidth

    if (width < 825) {
      return width * 0.93
    }
    if (width < 1200) {
      return width * 0.7
    }
    return width * 0.5
  }

  updateWindowDimensions () {
    this.setState({ richTextWidth: this.getRichTextWidth() })
  }

  componentDidMount () {
    this.updateWindowDimensions()
    window.addEventListener('resize', () => this.updateWindowDimensions())
  }

  componentWillUnmount () {
    window.removeEventListener('resize', () => this.updateWindowDimensions())
  }

  render () {
    const { html } = this.props
    const { richTextWidth } = this.state
    return (
      <RichTextDiv>
        <base target='_blank' />
        <RichTextCenter>
          <RichTextWrapper richTextWidth={richTextWidth} dangerouslySetInnerHTML={{ __html: html }} />
        </RichTextCenter>
      </RichTextDiv>
    )
  }
}

export default RichText
